import { useId, useState } from 'react';

export function PasscodeForm({
  rejected,
  submitLabel,
  busy,
  onSubmit,
}: {
  rejected: boolean;
  submitLabel: string;
  busy: boolean;
  onSubmit(passcode: string): void;
}) {
  const id = useId();
  const [value, setValue] = useState('');
  const errorId = `${id}-error`;

  return (
    <form
      className="passcode-form"
      onSubmit={(event) => {
        event.preventDefault();
        if (value.trim() === '' || busy) return;
        onSubmit(value.trim());
      }}
    >
      <label htmlFor={id}>Session passcode</label>
      <input
        id={id}
        type="password"
        inputMode="text"
        autoComplete="off"
        autoCapitalize="none"
        spellCheck={false}
        value={value}
        onChange={(event) => setValue(event.target.value)}
        aria-invalid={rejected}
        aria-describedby={rejected ? errorId : undefined}
      />
      {rejected ? (
        <p className="field-error" id={errorId} role="alert">
          That passcode was not accepted.
        </p>
      ) : null}
      <button type="submit" className="btn btn-primary" disabled={busy || value.trim() === ''}>
        {submitLabel}
      </button>
    </form>
  );
}
